import { useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { Message } from '@/types/discover';
import { SESSION_RESET_ALERT, CHATBOT_INITIAL_MESSAGE } from '@/pages/Lab/_constants/_const';

const useFilteredMessages = (localStorageKey: string, defaultMessage: Message) => {
  const [storedMessages, setStoredMessages] = useLocalStorage<Message[]>(localStorageKey, [
    defaultMessage,
  ]);

  // 1. 24시간 지난 메시지 제거
  const filteredMessages = storedMessages.filter((msg) => {
    if (msg.id === 0) return true;
    return Date.now() - msg.id <= 86400000;
  });

  // 2. 마지막 user 메시지 제거 + 알림 메시지 추가
  const intermediateMessages = [...filteredMessages];
  let shouldAddAlert = false;

  while (
    intermediateMessages.length > 0 &&
    intermediateMessages[intermediateMessages.length - 1].sender === 'user'
  ) {
    intermediateMessages.pop();
    shouldAddAlert = true;
  }

  if (shouldAddAlert) {
    intermediateMessages.push(SESSION_RESET_ALERT, CHATBOT_INITIAL_MESSAGE);
  }

  // 3. 마지막으로: 첫 메시지 외에 id === 0 제거
  const firstMessage = intermediateMessages[0];
  const finalMessages = [
    ...(firstMessage?.id === 0 ? [firstMessage] : []),
    ...intermediateMessages.slice(1).filter((msg) => msg.id !== 0),
  ];

  const [messages, setMessages] = useState<Message[]>(finalMessages);

  return { messages, setMessages, setStoredMessages };
};

export default useFilteredMessages;
